import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import VeraLabel from './vera-label';
import { colors } from '../../styles';

export interface Props {
  className?: string;
}

class VeraScoreLabel extends React.Component<Props> {
  public render() {
    const { className } = this.props;
    return <VeraLabel className={className}>&mdash;</VeraLabel>;
  }
}

export default styled(VeraScoreLabel)`
  color: ${colors.grey700};
  background-color: ${colors.grey300};
`;
